
import { Helmet } from "react-helmet-async";

import Hero from "../components/Hero";
import SearchBar from "../components/SearchBar";
import PopularAreas from "../components/PopularAreas";
import PopularDestinations from "../components/PopularDestinations";
import FeaturedHotels from "../components/FeaturedHotels";
import BookingBenefits from "../components/BookingBenefits";
import Testimonials from "../components/Testimonials";

// Hero slider images
import heroImg from "../assests/images/slider-1.webp";
import heroImg2 from "../assests/images/slider-2.webp";
import heroImg3 from "../assests/images/slider-3.webp";
import heroImg4 from "../assests/images/slider-4.webp";
import heroImg5 from "../assests/images/slider-5.webp";
import heroImg6 from "../assests/images/slider-6.webp";

// Keep the array outside the component to avoid
// creating a new array on every render.
const HERO_IMAGES = [
  heroImg,
  heroImg2,
  heroImg3,
  heroImg4,
  heroImg5,
  heroImg6,
];

export default function Home() {
  return (
    <main>
      <Helmet>
        <title>
          Dubai Budgetive Hotels | Affordable Hotels in Dubai
        </title>

        <meta
          name="description"
          content="Explore affordable hotels, apartments and resorts in Dubai with Dubai Budgetive Hotels. Compare accommodation options and find your ideal stay."
        />

        <link
          rel="canonical"
          href="https://dubaibudgetivehotels.com/"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Dubai Budgetive Hotels | Affordable Hotels in Dubai"
        />

        <meta
          property="og:description"
          content="Find affordable hotels, apartments and resorts in Dubai. Explore accommodation options with Dubai Budgetive Hotels."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://dubaibudgetivehotels.com/"
        />

        <meta
          property="og:image"
          content="https://dubaibudgetivehotels.com/images/default-og.png"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Dubai Budgetive Hotels | Affordable Hotels in Dubai"
        />

        <meta
          name="twitter:description"
          content="Explore affordable hotels, apartments and resorts across Dubai."
        />

        <meta
          name="twitter:image"
          content="https://dubaibudgetivehotels.com/images/default-og.png"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative">
        <Hero
          variant="home"
          title="Find the Best Hotel Deals in Dubai"
          subtitle="Save up to 60% on hotels, apartments and resorts across Dubai. Compare prices and book instantly."
          backgroundImages={HERO_IMAGES}
          slideInterval={5000}
        >
          <SearchBar />
        </Hero>
      </section>

      {/* Popular Areas */}
      <PopularAreas />

      {/* Popular Destinations */}
      <PopularDestinations
        limit={6}
        showViewAllButton={true}
      />

      {/* Featured Hotels */}
      <FeaturedHotels limit={6} />

      {/* Booking Benefits */}
      <BookingBenefits />

      {/* Guest Testimonials */}
      <Testimonials />
    </main>
  );
}
